var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { ActionTypes } from './actions';
export var defaultState = {
    token: null,
    isLoading: false,
    error: null,
};
export var reducer = function (state, action) {
    if (state === void 0) { state = defaultState; }
    switch (action.type) {
        case ActionTypes.VALIDATE_AUTH_FAIL:
            return __assign(__assign({}, state), { token: null });
        case ActionTypes.VALIDATE_AUTH_SUCCESS: {
            return __assign(__assign({}, state), { token: action.payload.token });
        }
        case ActionTypes.MAKE_LOGIN:
            return __assign(__assign({}, state), { isLoading: true, error: null, token: null });
        case ActionTypes.MAKE_LOGIN_SUCCESS:
            return __assign(__assign({}, state), { isLoading: false, token: action.payload.token });
        case ActionTypes.MAKE_LOGIN_FAIL:
            return __assign(__assign({}, state), { isLoading: false, error: action.payload.error });
        case ActionTypes.RESET_LOGIN_ERROR:
            return __assign(__assign({}, state), { error: null });
        default:
            return state;
    }
};
